import { render, staticRenderFns } from "./introductionPage.vue?vue&type=template&id=f61ffba2&scoped=true"
import script from "./introductionPage.vue?vue&type=script&lang=js"
export * from "./introductionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61ffba2",
  null
  
)

export default component.exports